/** The "Speaking too fast" banner on the live call: coaching for the rep who is speaking. */

/** The banner hides itself after this long. */
export const SPEECH_RATE_BANNER_HIDE_MS = 7000;

export const SPEECH_RATE_BANNER_COPY = {
  title: 'Speaking too fast:',
  detail: (wordsPerMinute: number, wpmThreshold: number): string =>
    `${wordsPerMinute} words per minute — the alert is set at ${wpmThreshold}`,
  dismiss: 'Dismiss',
} as const;
